module.exports = __webpack_public_path__ + "static/media/Drums1.5fda05b5.jpg";